export enum Modulo {
    MASTER = "Master",
    OPERACIONAIS_PROCESSOS_CREDOR = "operacionais-processos-credor"
}
